import React from 'react';
import './Errors.css';
import { Button } from '../../component/form/Button';
import { useNavigate } from 'react-router-dom';

const NotFound404: React.FC = () => {

    const nav = useNavigate();

    return (
        <div className="error-container">
            <h1 className="error-title">404 - Pagina Non Trovata</h1>
            <p className="error-message">
                Oops! La pagina che stai cercando non esiste.
            </p>
            <Button name='Torna alla Home' action={() => nav('/') } />
        </div>
    );
};

export default NotFound404;
